import { random } from 'lodash'
import * as React from 'react'
import { useTranslation } from 'react-i18next'

import { EmojiPicker, Mention } from '@/components'
import { PostType } from '@/generated/graphql'

import s from './post-editor.module.less'
import { PostEditorSetState, PostEditorState } from './post-editor.state'

interface PostEditorTextareaProps {
  textareaRef: React.RefObject<HTMLElement>
  rootRef: React.RefObject<HTMLElement>
  state: PostEditorState
  setState: PostEditorSetState
  setRootHeight: (height: number) => void
}

export const PostEditorTextarea: React.FC<PostEditorTextareaProps> = ({
  state,
  setState,
  rootRef,
  textareaRef,
  setRootHeight,
}) => {
  const [t] = useTranslation()

  const impactPlaceholder = [
    t('impact.tip.textPlaceholder1'),
    t('impact.tip.textPlaceholder2'),
    t('impact.tip.textPlaceholder3'),
    t('impact.tip.textPlaceholder4'),
  ]
  const [placeholderIndex] = React.useState(() => random(0, impactPlaceholder.length - 1))

  const emojiPicker = (
    <EmojiPicker
      className={s.emojiPicker}
      onClick={(emoji) => {
        const textarea: HTMLTextAreaElement = (textareaRef as any).current
        const { selectionStart, selectionEnd, value: s } = textarea
        const content = s.substring(0, selectionStart) + emoji + s.substring(selectionEnd, s.length)
        setState((state) => ({ ...state!, content }))
        // textarea value 改变后光标被移到了末尾，将光标移回开始前的地方
        window.setTimeout(() => {
          textarea.selectionStart = selectionStart + emoji.length
          textarea.selectionEnd = textarea.selectionStart
        }, 0)
      }}
    />
  )

  return (
    <div className={s.textareaContainer}>
      <Mention
        ref={textareaRef}
        autoFocus
        autoSize={false}
        value={state.content}
        border={false}
        placeholder={
          state.postType === PostType.Forum ? t('post.forum.inputPlaceholder') : impactPlaceholder[placeholderIndex]
        }
        onValueChange={(content) => {
          setState((state) => ({ ...state!, content }))
          window.setTimeout(() => {
            setRootHeight(
              rootRef.current!.offsetHeight + (textareaRef.current!.scrollHeight - textareaRef.current!.offsetHeight)
            )
          }, 0)
        }}
      />
      {emojiPicker}
    </div>
  )
}
